<template>
    <div class="c-scrollbar" v-if="visible">
        <div class="c-scrollbar--thumb" :style="style"></div>
    </div>
</template>

<script>
export default {
    name : "Scrollbar",
    props: {
        containerid: {
            type: String
        },
        count: {
            type:  Number
        }
    },
    data() {
        return {
            style: {},
            thumbHeight : 100,
            visible : false
        };
    },

    watch: {
        count() {
            this.visible = this.container.scrollHeight > this.container.clientHeight;
        }
    },

    mounted() {
        this.container = document.getElementById(this.containerid);

        this.visible = this.container.scrollHeight > this.container.clientHeight;
        window.requestAnimationFrame(this.updateScrollPosition);
    },

    methods: {
        updateScrollPosition() {
            const height = this.container.clientHeight;
            const scrollDistance = this.container.scrollHeight - height;
            const scale = (height - this.thumbHeight) / height;
            const top = this.container.scrollTop / scrollDistance * 100 * scale;
            this.style = {top : top + "%", height : this.thumbHeight + "px"};

            this.visible = this.container.scrollHeight > this.container.clientHeight;

            if (!this._isDestroyed) {
                window.requestAnimationFrame(this.updateScrollPosition);
            }
        }
            
    }
};
</script>

<style lang="scss" scoped>
    .c-scrollbar {
        position: absolute;
        width : .4rem;
        height : calc(100% - .35rem);
        right : 0em;
        top : .2rem;

        &--thumb {
            position: absolute;
            background : #dddddd;
            width : 100%;
            border-radius: .15rem;
        }
    }
</style>